import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import hubroLogo from '../assets/HubroSimulations.png';
import hubspotLogo from '../assets/EPP Logo 2022_Trans.png';
import nujournyeLogo from '../assets/nj-color-main.png';
import CookiePreferencesModal from '../components/modals/CookiePreferencesModal';
import DoNotSellModal from '../components/modals/DoNotSellModal';

export default function Footer() {
  const [showCookiePreferences, setShowCookiePreferences] = useState(false);
  const [showDoNotSell, setShowDoNotSell] = useState(false);

  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-center space-y-8">
          <Link to="/" className="flex items-center space-x-2">
            <img src={logo} alt="Emploskills Logo" className="h-8 w-auto" />
            <span className="text-xl font-bold text-gray-900">Emploskills</span>
          </Link>

          {/* Partners Section */}
          <div className="flex flex-col items-center space-y-6 w-full max-w-3xl">
            <h3 className="text-sm font-medium text-gray-500">Proud Partnerships</h3>
            
            {/* Hubro Partnership */}
            <div className="flex flex-col items-center space-y-2">
              <p className="text-sm text-gray-500">Official partner for Secondary & Vocational Education</p>
              <a 
                // href="" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-80"
              >
                <img 
                  src={hubroLogo} 
                  alt="Hubro Simulations Logo" 
                  className="h-12 w-auto"
                />
              </a>
            </div>

            {/* Partners Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
              {/* Hubspot Educational Partner */}
              <div className="flex flex-col items-center space-y-2">
                <p className="text-sm text-gray-500">Proud member of HubSpot Educational Partner Program</p>
                <a 
                  href="https://www.hubspot.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="transition-opacity hover:opacity-80"
                >
                  <img 
                    src={hubspotLogo} 
                    alt="HubSpot Educational Partner Program Logo" 
                    className="h-12 w-auto"
                  />
                </a>
              </div>

              {/* NuJournye Foundation */}
              <div className="flex flex-col items-center space-y-2">
                <p className="text-sm text-gray-500">Proud partner of NuJournye Foundation</p>
                <a 
                  href="https://www.nujourneyfoundation.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="transition-opacity hover:opacity-80"
                >
                  <img 
                    src={nujournyeLogo} 
                    alt="NuJournye Foundation Logo" 
                    className="h-12 w-auto"
                  />
                </a>
              </div>
            </div>
          </div>
          
          <nav className="flex flex-wrap justify-center gap-4 md:gap-6">
            <Link
              to="/privacy-policy"
              className="text-gray-500 hover:text-primary transition-colors text-sm"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              className="text-gray-500 hover:text-primary transition-colors text-sm"
            >
              Cookie Policy
            </Link>
            <button
              onClick={() => setShowCookiePreferences(true)}
              className="text-gray-500 hover:text-primary transition-colors text-sm"
            >
              Cookie Settings
            </button>
            <button
              onClick={() => setShowDoNotSell(true)}
              className="text-gray-500 hover:text-primary transition-colors text-sm"
            >
              Do Not Sell My Info
            </button>
            <a
              href="mailto:contact@emploskills.com"
              className="text-gray-500 hover:text-primary transition-colors text-sm"
            >
              Contact
            </a>
          </nav>

          <p className="text-gray-500 text-sm text-center">
            © {new Date().getFullYear()} Emploskills. All rights reserved.
          </p>
        </div>
      </div>

      {/* Modals */}
      {showCookiePreferences && (
        <CookiePreferencesModal
          isOpen={showCookiePreferences}
          onClose={() => setShowCookiePreferences(false)}
        />
      )}

      {showDoNotSell && (
        <DoNotSellModal
          isOpen={showDoNotSell}
          onClose={() => setShowDoNotSell(false)}
        />
      )}
    </footer>
  );
}